var map = {
	"./AR.svg": "d4cf",
	"./AT.svg": "f82b",
	"./BE.svg": "b14f",
	"./BN.svg": "b2c1",
	"./BR.svg": "8ab7",
	"./BY.svg": "60ec",
	"./CA.svg": "b284",
	"./CH.svg": "9076",
	"./DE.svg": "4793",
	"./DK.svg": "7d2b",
	"./ES.svg": "9bf5",
	"./FI.svg": "ec09",
	"./FR.svg": "796e",
	"./ID.svg": "18a4",
	"./IT.svg": "f4fd",
	"./KH.svg": "a9c0",
	"./LA.svg": "9429",
	"./MM.svg": "328f",
	"./MX.svg": "dc2d",
	"./MY.svg": "66d2",
	"./NL.svg": "7ede",
	"./NO.svg": "d1f7",
	"./NZ.svg": "b242",
	"./PH.svg": "1dfe",
	"./PL.svg": "6fcc",
	"./RU.svg": "b222",
	"./SE.svg": "8bfd",
	"./SG.svg": "37ac",
	"./TH.svg": "17af",
	"./US.svg": "6c06",
	"./VN.svg": "ea5e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0e67";